module.exports = __webpack_public_path__ + "1c6d765fe6ece18e00e1c25d59698e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/tsutayaelectrics.png
// module id = 83
// module chunks = 0